<template>
<create-paycode v-if="action === 'create'"></create-paycode>
  <div class="container" v-else>
    <ul class="uk-subnav uk-subnav-pill" uk-switcher>
      <li><a href="#">paycode</a></li>
      <li><a href="#">assessments</a></li>
      <li><a href="#">users</a></li>
      <li><a href="#">statistics</a></li>
    </ul>

    <ul class="uk-switcher uk-margin">
        <li>
          <paycode></paycode>
        </li>
        <li>
          <list-assessments></list-assessments>
        </li>
        <li>
          <users></users>
        </li>
        <li>
          <statistics></statistics>
        </li>
    </ul>
  </div>
</template>

<script>
import Users from '@/components/Users';
import ListAssessments from '@/components/ListAssessments';
import Statistics from '@/components/Statistics';
import PayCode from '@/components/PayCode';
import CreatePayCode from '@/components/CreatePayCode';
export default {
    name: 'Management',
    components: {
      'users': Users,
      'list-assessments': ListAssessments,
      'statistics': Statistics,
      'paycode': PayCode,
      'create-paycode': CreatePayCode,
    },
    computed: {
        action() {
            return this.$route.name.split('.')[2];
        }
    },
}
</script>

<style>

</style>